import { Controller } from '@hotwired/stimulus';
import { PopoverController } from '@elc-online/edl-components/js/popover';

export default class extends Controller {
  static readonly targets = ['popover', 'container', 'trigger', 'close'];

  declare popoverTarget: HTMLElement;
  declare containerTarget: HTMLElement;
  declare triggerTarget: HTMLButtonElement;
  declare closeTarget: HTMLButtonElement;

  initialize(): void {
    new PopoverController(
      {
        popover: this.popoverTarget,
        container: this.containerTarget,
        trigger: this.triggerTarget,
        close: this.closeTarget,
      },
      {
        mode: 'auto',
      },
    );
  }
}
